import axiosInstance from '../../../lib/axios'
import { API_ENDPOINTS } from '../../../constants/api'
import type { Incident, IncidentSource, IncidentStatus, IncidentStatusUpdate } from '../types/incident.types'

export interface IncidentListParams {
  property_id?: number
  status?: IncidentStatus
  source?: Exclude<IncidentSource, null>
  assignee_user_id?: number
}

function buildListQuery(params: IncidentListParams): string {
  const search = new URLSearchParams()
  if (params.property_id !== undefined) search.set('property_id', String(params.property_id))
  if (params.status !== undefined) search.set('status', params.status)
  if (params.source !== undefined) search.set('source', params.source)
  if (params.assignee_user_id !== undefined) search.set('assignee_user_id', String(params.assignee_user_id))
  const qs = search.toString()
  return qs ? `?${qs}` : ''
}

export const incidentsService = {
  async list(params: IncidentListParams = {}): Promise<Incident[]> {
    const { data } = await axiosInstance.get<Incident[]>(`${API_ENDPOINTS.TASKS}${buildListQuery(params)}`)
    return data
  },

  async getById(id: number): Promise<Incident> {
    const { data } = await axiosInstance.get<Incident>(API_ENDPOINTS.TASK_BY_ID(id))
    return data
  },

  async updateStatus(id: number, body: IncidentStatusUpdate): Promise<Incident> {
    const { data } = await axiosInstance.put<Incident>(API_ENDPOINTS.TASK_STATUS(id), body)
    return data
  },
}
